//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "AQRadio",
    props: {
        val: { String, Boolean },
        value: { String, Boolean },
        label: { type: String, default: "" },
        isDisabled: { type: Boolean, default: false },
        leftLabel: { type: Boolean, default: false }
    },
    methods: {
        setValue(newVal) {
            this.$emit("input", newVal);
        }
    }
};
